import { cloneDeep } from "lodash";
import React, { useEffect, useState } from "react";
import AppButton from "../../common/AppButton";
import AppNavPills from "../../common/AppNavPills";
import AppSelect from "../../common/AppSelect";
import DetailBlock from "../../common/DetailBlock";
import LabelInput from "../../common/LabelInput";
import numberFormat from "../../common/numberFormat";
import Body from "../../components/Body";
import expenseNavs from "../../components/expenseNavs";
import api from "../../config/api";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getExpenseCategories } from "../../stores/ExpenseCategoryStore";

const formInit = {
  date: new Date().toISOString(),
  category: "",
  amount: "",
  comment: "",
};
export default function ExpensesAdd() {
  const navigate = useNavigate();
  const [form, setForm] = useState(cloneDeep(formInit));
  const [focus, setFocus] = useState();
  const [disabled, setDisabled] = useState(false);
  const queryClient = useQueryClient();

  const { data: categories } = useQuery({
    queryFn: () => getExpenseCategories(),
    queryKey: ["expenseCategory"],
  });

  const handleChange = ({ currentTarget }) => {
    const name = currentTarget.name;
    const value = currentTarget.value;
    setForm({ ...form, [name]: value });
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!form.category) {
      return setFocus({ ...focus, category: Math.random() });
    }

    setDisabled(true);
    const cat = categories?.find((i) => i.category === form.category);
    const res = await api.post("expenses", { ...form, category: cat._id });
    if (!res.ok) {
      setDisabled(false);
      toast.error(res.originalError.message);
    }
    queryClient.invalidateQueries(["expenses"]);

    setForm(formInit);
    setDisabled(false);
    toast.success("Expense has been successfully added.");
  };

  return (
    <Body
      title="Expenses"
      topRight={
        <AppButton
          onClick={() => {
            navigate("/expenses/paySalary");
          }}
          text="Pay Salary"
          className="btn-warning"
        />
      }
    >
      <div>
        <AppNavPills list={expenseNavs} />
        <div style={{ marginTop: 30 }}>
          <form onSubmit={handleSubmit}>
            <DetailBlock>
              <div
                className="d-flex"
                style={{ gap: "0px 40px", width: 800, flexWrap: "wrap" }}
              >
                <LabelInput
                  name="date"
                  placeholder="Date"
                  datePicker
                  value={form.date}
                  onChange={handleChange}
                  required
                  containerStyle={{ height: 90 }}
                />
                <AppSelect
                  name="category"
                  value={form.category}
                  onChange={handleChange}
                  required
                  placeholder="Category"
                  focused={focus?.category}
                  containerStyle={{ height: 95 }}
                  options={categories?.map((i) => i.category)}
                />
                <LabelInput
                  name="amount"
                  value={numberFormat(form.amount)}
                  onChange={handleChange}
                  required
                  placeholder="Amount"
                  containerStyle={{ height: 90 }}
                />
                <LabelInput
                  name="invoice"
                  value={form.invoice}
                  onChange={handleChange}
                  required
                  placeholder="Invoice"
                  containerStyle={{ height: 90 }}
                />
                <LabelInput
                  name="comment"
                  value={form.comment}
                  onChange={handleChange}
                  required
                  placeholder="Comment"
                  containerStyle={{ height: 90 }}
                />
              </div>
            </DetailBlock>
            <AppButton
              disabled={disabled}
              text="Add Expense"
              className="btn-primary"
              style={{ margin: "10px 0px" }}
            />
          </form>
        </div>
      </div>
    </Body>
  );
}
